import React from 'react'
import SystemPerformance from '../../components/SystemPerformance/SystemPerformance'

const index = () => {
  return (
    <div>
       <SystemPerformance/>
    </div>
  )
}

export default index